/**
 * @generated SignedSource<<c449cadb4c1b6eda4ef6984a492c75a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAttachmentInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteAttachmentMutation$variables = {
  input: DeleteAttachmentInput;
};
export type deleteAttachmentMutation$data = {
  readonly deleteAttachment: {
    readonly clientMutationId: string | null;
    readonly deletedAttachmentId: string | null;
  } | null;
};
export type deleteAttachmentMutation = {
  variables: deleteAttachmentMutation$variables;
  response: deleteAttachmentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAttachmentPayload",
    "kind": "LinkedField",
    "name": "deleteAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAttachmentId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteAttachmentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteAttachmentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5a93a24329713545048164a24b838a6",
    "id": null,
    "metadata": {},
    "name": "deleteAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation deleteAttachmentMutation(\n  $input: DeleteAttachmentInput!\n) {\n  deleteAttachment(input: $input) {\n    clientMutationId\n    deletedAttachmentId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9da60e1d53fc576c63999884723134ba";

export default node;
